import { sidebarIcon } from './icons'
import type { SidebarLink, SidebarRow } from './model'

export interface SidebarRowGroup {
  label: string | null
  links: SidebarLink[]
}

/** The rows a service sent, ready to draw: consecutive rows sharing a heading make one group. */
export function groupRows(rows: SidebarRow[]): SidebarRowGroup[] {
  const groups: SidebarRowGroup[] = []
  for (const row of rows) {
    const link: SidebarLink = {
      title: row.title,
      url: row.url,
      icon: sidebarIcon(row.icon),
      collapsedIcon: row.collapsedIcon ? sidebarIcon(row.collapsedIcon) : undefined,
      exact: row.exact,
    }
    const last = groups.at(-1)
    if (last && last.label === row.group) last.links.push(link)
    else groups.push({ label: row.group, links: [link] })
  }
  return groups
}
